module.exports = __webpack_public_path__ + "img/icon-room.0000d9fd.svg";